import { Flex, Separator } from '@chakra-ui/react';
import { type EmojiProps, formatEmojiId, useEditorContext } from '@halo/ui-chat-react';
import { StickerSetType } from '@halo/chat-sdk';
import { ImageUploader } from './ImageUploader';
import { MentionButton } from './Mention‌Button';
import { FileUploader } from './FileUploader';
import { EmojiButton } from './EmojiButton';
import { ExpireTimeSelector } from './ExpireTimeSelector';
import { MessageMoreButton } from './MessageMoreButton';

interface ToolBarProps {
  duration: number | undefined;
  isGroup: boolean;
  isMe: boolean;
  readonly: boolean;
  onDurationChange: (duration: number) => void;
  onClickImage: () => void;
  onClickFile: () => void;
  onLuckyChange: (value: string) => void;
  onSelectSticker: (emojiId: string, groupId: string) => void;
}

export function ToolBar({
  duration,
  isGroup,
  isMe,
  onDurationChange,
  onClickImage,
  onClickFile,
  onLuckyChange,
  onSelectSticker,
}: ToolBarProps) {
  const { editor } = useEditorContext();

  const onSelectEmoji = useCallback<EmojiProps['onSelect']>(
    (emojiId, groupId, type) => {
      if (type === StickerSetType.Emoji) {
        editor.insertText(formatEmojiId(emojiId));
        editor.focus();
      }
      if (type === StickerSetType.Sticker) {
        onSelectSticker(emojiId, groupId);
      }
    },
    [editor, onSelectSticker]
  );

  const onAddMention = useCallback(() => {
    editor.insertText('@');
    editor.focus();
  }, [editor]);

  const preventDefault = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  return (
    <Flex
      className="ToolBar"
      gap="1"
      align="center"
      color="fg"
      onMouseDown={preventDefault}
      onClick={preventDefault}
      fontSize="sm"
    >
      <ExpireTimeSelector value={duration} onChange={onDurationChange} />
      <EmojiButton onSelect={onSelectEmoji} />
      {isGroup && <MentionButton onClick={onAddMention} />}
      <ImageUploader onClick={onClickImage} />
      <FileUploader onClick={onClickFile} />
      {!isMe && <MessageMoreButton isGroup={isGroup} onChange={onLuckyChange} />}
      <Separator orientation="vertical" height="1em" w="1px" borderColor="border.line" m="auto" />
    </Flex>
  );
}
